import type { LegacyRegistrationRedirectConfig } from '../../registration.types.ts';

const MAIN_LEGACY_HOSTS = ['www.lottoland.co.uk', 'lottoland.co.uk'];
const HELP_LEGACY_HOST = 'help.lottoland.co.uk';

const UK_LEGACY_REGISTRATION_REDIRECT: LegacyRegistrationRedirectConfig = {
  legacyHosts: [...MAIN_LEGACY_HOSTS, HELP_LEGACY_HOST],
  fallbackDestination: '/?deposit-amount=0',
  pathMappings: [
    {
      hosts: [HELP_LEGACY_HOST],
      path: '/embed/lopetto/',
      destination: 'https://help.lottoland.co.uk/embed/lopetto/?entry=chroma',
    },
    {
      hosts: [HELP_LEGACY_HOST],
      path: '/',
      destination: 'https://help.lottoland.co.uk/?entry=chroma',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/',
      destination: '/',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/promotions',
      destination: '/promotions',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/casino',
      destination: '/casino',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/live-casino',
      destination: '/live-casino',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/sportsbook',
      query: { page: 'overview' },
      destination: '/sportsbook',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/bingo',
      destination: '/bingo',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/account/profile',
      destination: '/my-account',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/lotto-betting',
      destination: '/lotto-betting',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/magazine',
      destination: '/magazine',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/payouts',
      destination: '/payouts',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/privacy',
      destination: '/privacy',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/terms',
      destination: '/terms',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/terms-summary',
      destination: '/terms-summary',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/cookiepolicy',
      destination: '/cookiepolicy',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/gamefairness',
      destination: '/gamefairness',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/complaints-procedure',
      destination: '/complaints-procedure',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/accessibilitystatement',
      destination: '/accessibilitystatement',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/gamble-safely',
      destination: '/gamble-safely',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/support-networks',
      destination: '/gamble-safely',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/underage-protection',
      destination: '/underage-protection',
    },
    {
      hosts: MAIN_LEGACY_HOSTS,
      path: '/documentsneeded',
      destination: '/documentsneeded',
    },
  ],
};

export { UK_LEGACY_REGISTRATION_REDIRECT };
